<p-toast></p-toast>
<div class="search">
  <div class="search_data">
    <!-- <div class="bg_1 p-x-40 p-y-17 dis_flex font_13 weight_600">
      <div
        class="dis_flex align_center color_blue cursor_pointer"
        (click)="resetSearch()"
      >
        Back to Search
      </div>
      <div class="dis_flex align_center p-x-16">
        <svg
          width="7"
          height="8"
          viewBox="0 0 7 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030"
          />
        </svg>
      </div>
      <div class="dis_flex align_center">{{ searchQueryGrid }}</div>
    </div>
    <div class="search_data_container">
      <div class="search_data_container_input">
        <img
          class="search_data_container_input_icon z_index_1"
          src="../../../assets/icons/search_icon.png"
        />
        <input
          #inputQuery
          id="inputSearchQuery"
          type="text"
          class="search_data_container_input_box form-control"
          id="search_input"
          [(ngModel)]="searchQueryGrid"
          (input)="validateQuery($event)"
          placeholder="Type Your Query"
        />
        <button
          type="button"
          class="search_data_container_input_button color_white font_13 weight_600 p-x-40 p-y-10 bg_3"
          (click)="searchQuery()"
          [disabled]="isValidQueryCondition == false"
        >
          Search
        </button>
        <div
          class="search_data_container_input_suggestion bg_1 p-y-8 p-x-16 border-radius-6 z_index_3"
          *ngIf="isShowQueryBox"
        >
          <ng-container *ngIf="dropdownSuggestions.length">
            <ng-container
              *ngFor="let item of dropdownSuggestions; let i = index"
            >
              <div
                class="search_top_body_container_simple_mid_right_suggestion_item p-y-8 color_black font_14 weight_500 cursor_pointer"
                (click)="autoQuerySelect(item)"
              >
                <div>
                  <img src="../../../assets/icons/search_icon.png" />
                </div>
                <div>{{ item.columnName }}</div>
                <div class="text_end weight_700">
                  <span class="bg_8 border-radius-4_1 p-x-8 p-y-3">{{
                    item.label
                  }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="search_data_container_download" *ngIf="totalRecords > 0">
        <span class="color_black font_14 weight_700">Download as:</span>
        <div
          class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
          (click)="exportPdf()"
        >
          <div class="dis_flex jc_center">
            <img width="50%" src="../../../assets/icons/download.png" />
          </div>
          <span class="color_black font_9 weight_500">PDF</span>
        </div>
        <div
          class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
          (click)="exportExcel('csv')"
        >
          <div class="dis_flex jc_center">
            <img width="50%" src="../../../assets/icons/download.png" />
          </div>
          <span class="color_black font_9 weight_500">CSV</span>
        </div>
        <div
          class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
          (click)="exportExcel('xlsx')"
        >
          <div class="dis_flex jc_center">
            <img width="50%" src="../../../assets/icons/download.png" />
          </div>
          <span class="color_black font_9 weight_500">XLS</span>
        </div>
      </div>
    </div>
    <div class="search_data_download1" *ngIf="totalRecords > 0">
      <span class="color_black font_14 weight_700">Download as:</span>
      <div
        class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
        (click)="exportPdf()"
      >
        <div class="dis_flex jc_center">
          <img width="50%" src="../../../assets/icons/download.png" />
        </div>
        <span class="color_black font_9 weight_500">PDF</span>
      </div>
      <div
        class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
        (click)="exportExcel('csv')"
      >
        <div class="dis_flex jc_center">
          <img width="50%" src="../../../assets/icons/download.png" />
        </div>
        <span class="color_black font_9 weight_500">CSV</span>
      </div>
      <div
        class="width_41 p-8 m-l-15 border-radius-6 bg_8 dis_flex flex_col aspect_ratio_1 text-center cursor-pointer"
        (click)="exportExcel('xlsx')"
      >
        <div class="dis_flex jc_center">
          <img width="50%" src="../../../assets/icons/download.png" />
        </div>
        <span class="color_black font_9 weight_500">XLS</span>
      </div>
    </div>
    <div class="search_data_box dis_flex flex_wrap" *ngIf="totalRecords > 0">
      <ng-container *ngFor="let patent of patentTypes; let i = index">
        <div class="p-top-24">
          <button
            *ngIf="patent.patentType !== 'All' && patent.labelType === 'Main'"
            type="button"
            class="font_12 weight_700 m-r-16 p-x-16 p-y-12 border-radius-6 border_blue_1"
            [ngClass]="
              patent.patentType === dynSelectedPatentType
                ? 'color_white bg_3'
                : 'color_blue bg_1'
            "
            (click)="selectPatentType(patent.patentType)"
          >
            {{ patent.patentType }}
          </button>
        </div>
      </ng-container>
    </div> -->
    <div class="search_data_box dis_flex flex_wrap">
      <ng-container *ngFor="let patent of patentTypes; let i = index">
        <div class="p-top-24">
          <button type="button" class="font_12 weight_700 m-r-16 p-x-16 p-y-12 border-radius-6 border_BLUE_1"
            style="font-weight: 700; font-size: 12px; padding: 10px" [ngClass]="
              patent.patentType === dynSelectedPatentType
                ? 'color_white bg_33'
                : 'color_blue bg_1'
            " (click)="selectPatentType(patent.patentType)">
            {{ patent.patentType }}
          </button>
        </div>
      </ng-container>
    </div>

    <div class="search_data_flexbox">
      <div class="search_data_flexbox_item1 color_black font_20 weight_800" *ngIf="totalRecords >= 0" style="
          font-size: 18px;
          font-weight: 800;
          background: linear-gradient(90deg, #0032a0, #0032a0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        ">
        Record(s) Count: <span class="color_blue">{{ totalRecords }}</span>
      </div>
      <div class="search_data_flexbox_item2 font_13 weight_600" *ngIf="totalRecords > 0">
        <!-- <div class="search_data_flexbox_item2_sort" *ngIf="!isListView">
          <span class="color_black font_13 weight_600 p-r-10">Sort By :</span>
          <select
            class="search_data_flexbox_item2_sort_select"
            [(ngModel)]="listSortByfield"
            (change)="sortBydata()"
          >
            <option>Sort By</option>
            <option *ngFor="let col of cols">{{ col.header }}</option>
          </select>
          <div class="search_top_body_container_simple_mid_left_box">
            <div class="dis_flex align_center">
              <input
                type="radio"
                id="sort_asc"
                value="ASC"
                [(ngModel)]="listSortOrder"
              />
              <label for="sort_asc" class="p-l-8 color_black font_14 weight_500"
                >Asc</label
              >
            </div>
            <div
              class="dis_flex align_center search_top_body_container_simple_mid_left_box_two"
            >
              <input
                type="radio"
                id="sort_desc"
                value="DESC"
                [(ngModel)]="listSortOrder"
              />
              <label
                for="sort_desc"
                class="p-l-8 color_black font_14 weight_500"
                >Desc</label
              >
            </div>
          </div>
        </div> -->

        <!-- <button
        style="color: white; background-color: #0032a0; padding: 8px 16px; border: none; border-radius: 20px; font-size: 14px; cursor: pointer; margin-right: 15px;"
        (click)="showFullScreen()"
      >
        Full Screen View
      </button>
        <button
          class="search_data_flexbox_item2_btn color_white bg_3 p-x-24 p-y-10 border_none border-radius-30 back-button"
          *ngIf="isFullScreen"
          (click)="exitFullScreen()"
        >
          Back-button
        </button> -->

        <!-- <button
          class="search_data_flexbox_item2_btn color_black bg_8 p-x-24 p-y-10 border_none border-radius-30"
          (click)="showRaiseQuery()"
        >
          Raise Query
        </button> -->
        <button *ngIf="!isListView" style="
            background-color: #ffcd04;
            color: black;
            padding: 10px 30px;
            font-size: 14px;
            border: none;
            border-radius: 30px;
            margin-right: 15px;
            cursor: pointer;
            display: inline-block;
          " (click)="showDetailView(!productDetails)">
          Detail View
        </button>

        <button style="
            color: white;
            background-color: #0032a0; /* replace with your bg_3 color */
            padding: 10px 30px;
            font-size: 14px;
            border: none;
            border-radius: 30px;
            display: inline-block;
            cursor: pointer;
            margin-right: 15px;
          " (click)="showAnalysisView(true)">
          Analysis
        </button>

        <button style="
            background-color: #ffcd04;
            padding: 8px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            margin-right: 15px;
          " (click)="showFieldSettingModal()">
          <img src="../../../assets/icons/settings.png" />
        </button>

        <!-- List View Button -->
        <button [ngStyle]="{
            color: isListView ? 'white' : 'black',
            backgroundColor: isListView ? '#0032a0' : '#f9f9f9',
            padding: '7px 7px',
            border: '1px solid #0032a0',
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }" (click)="isListView = true; productDetails = productDetails">
          <img *ngIf="!isListView" src="../../../assets/icons/list_view_black.png" />
          <img *ngIf="isListView" src="../../../assets/icons/list_view_white.png" />
          List View
        </button>

        <!-- Grid View Button -->
        <button [ngStyle]="{
            color: !isListView ? 'white' : 'black',
            backgroundColor: !isListView ? '#0032a0' : '#f9f9f9',
            padding: '7px 7px',
            border: '1px solid #007bff',
            borderTopRightRadius: '6px',
            borderBottomRightRadius: '6px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }" (click)="isListView = false; productDetails = false">
          <img *ngIf="!isListView" src="../../../assets/icons/grid_view_white.png" />
          <img *ngIf="isListView" src="../../../assets/icons/grid_view_black.png" />
          Grid View
        </button>
        <!-- <button
          style="
            background-color: #ffcd04;
            padding: 8px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            margin-right: 15px;
            margin-left: 10px;
          "
          (click)="exportPdf()"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <img src="../../../../assets/icons/download.png" alt="Download" />
            <span style="font-size: 12px; color: #000; margin-top: 4px"
              >PDF</span
            >
          </div>
        </button> -->

        <button style="
            background-color: #ffcd04;
            padding: 8px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            margin-left: 15px;
          " (click)="exportExcel('csv')">
          <img src="../../../../assets/icons/download.png" />
          <span style="font-size: 12px; color: #000; margin-top: 4px">CSV</span>
        </button>
        <button style="
            background-color: #ffcd04;
            padding: 8px;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            margin-left: 15px;
          " (click)="exportExcel('xlsx')">
          <img src="../../../../assets/icons/download.png" />
          <span style="font-size: 12px; color: #000; margin-top: 4px">XLS
          </span>
        </button>
      </div>
    </div>

    <!-- ANALYSIS VIEW -->
    <div class="search_data_analysis p-top-10" *ngIf="analysisData && analysisView">
      <div class="bg_1 p-bot-10 border-radius-20" [ngClass]="analysisView ? 'slide-down' : 'slide-up'">
        <div class="color_black font_20 weight_600 p-x-16 p-top-10" style="font-size: 20px; font-weight: 600">
          Analysis
        </div>
        <div class="color_black font_14 weight_600 p-x-16 p-top-10 text_decoration_underline" style="font-weight: 400">
          Filters
        </div>
        <div class="p-x-16">
          <ng-container *ngIf="!analysisFilterVal.length">
            <span class="color_black font_14 weight_500">
              No filter applied.</span>
          </ng-container>
          <ng-container *ngIf="analysisFilterVal.length">
            <div class="dis_flex flex">
              <div class="p-y-10 p-r-10">
                <button type="button" *ngFor="let analysis of analysisFilterVal" title="Remove"
                  (click)="removeAnalysisFilter(analysis)" style="
                    background-color: #688be6; /* bg_10 */
                    border: none; /* border_none */
                    border-radius: 6px; /* border-radius-6 */
                    color: white; /* color_white */
                    font-size: 12px; /* font_12 */
                    font-weight: 600; /* weight_600 */
                    padding: 10px 10px; /* p-y-10 p-x-10 */
                    margin-right: 5px;
                    cursor: pointer;
                  ">
                  {{ analysis.filter }} = {{ analysis.value }}
                  <span style="
                      color: red; /* color_red */
                      font-weight: 700; /* weight_700 */
                      padding: 3px; /* padding_3 */
                      background-color: white; /* bg_1 */
                      margin-left: 5px;
                      border-radius: 3px;
                      display: inline-block;
                    ">
                    X
                  </span>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="search_data_analysis_cols p-top-10 p-b-20">
          <ng-container *ngFor="let filter of analysisDataKeys">
            <div class="color_black m-x-16 border_BLUE_1 border-radius-10">
              <div class="bg_2 font_14 weight_600 text-center p-x-16 p-y-10 border-radius-10">
                {{ filter }}
              </div>
              <div class="search_data_analysis_cols_body">
                <div class="search_data_analysis_cols_body_item dis_flex p-x-16 p-y-5 font_14 weight_500 cursor_pointer"
                  (click)="analysisFilter(filter, row._id)" *ngFor="let row of analysisData[filter]">
                  <div class="width_80_per">
                    {{ row._id ? row._id : "Not Available" }}
                  </div>
                  <div class="width_20_per text_end">
                    {{ row.dataCount }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="totalRecords == 0">
      <!--  <ng-template  > -->
      <div class="no-results-container">
        <img src="../../../assets/img/no-data.png" class="no-results-image" />
        <div class="no-results-message color_black">
          <span class="font_20 weight_800">Sorry – The search found zero results. Why…</span>
          <ul class="no-results-list text_start">
            <li>
              <span class="font_20 weight_500">Make sure you have selected the correct search criteria</span>
            </li>
            <li>
              <span class="font_20 weight_500">Make sure that all words are spelled correctly</span>
            </li>
            <li>
              <span class="font_20 weight_500">Try different keywords</span>
            </li>
            <li>
              <span class="font_20 weight_500">Try more general keywords</span>
            </li>
          </ul>
        </div>
        <!-- Back to search button -->
        <!-- <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button> -->
      </div>
      <!-- </ng-template> -->
    </div>

    <div id="tabledata" class="search_data_table" [ngClass]="{ 'full-screen': isFullScreen }" *ngIf="totalRecords > 0">
      <div class="p-top-10 search_data_table_body" [ngClass]="
          !isListView && productDetails
            ? 'search_data_table_view'
            : 'width_100_per'
        ">
        <div class="search_data_table_body_box" *ngIf="isListView" [ngClass]="{ fullscreen: isFullScreen }">
          <div
            class="scroll-button-left bg_1 width_40 height_40 border-radius-50-per padding-3 m-t-30 m-r-10-neg z_index_3 shadow_effect_2 cursor_pointer"
            longPress (mouseLongPress)="scrollLeft()" (click)="scrollLeft()">
            <div class="bg_2 width_100_per height_100_per dis_flex jc_center align_center border-radius-50-per">
              <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.70415 1.90735e-05C7.55932 -0.000854492 7.41575 0.0280972 7.28167 0.0852137C7.14759 0.14233 7.02564 0.22649 6.92281 0.332864L0.320008 7.21929C0.115045 7.43433 0 7.72523 0 8.02844C0 8.33166 0.115045 8.62255 0.320008 8.8376L6.92281 15.724C7.13334 15.912 7.40413 16.0103 7.6811 15.9991C7.95806 15.988 8.22078 15.8682 8.41677 15.6638C8.61276 15.4594 8.72757 15.1854 8.73827 14.8966C8.74897 14.6077 8.65476 14.3253 8.47447 14.1057L2.653 8.03418L8.47447 1.96265C8.629 1.8028 8.73462 1.59875 8.77796 1.37631C8.8213 1.15386 8.80043 0.923006 8.71797 0.712933C8.63552 0.50286 8.49519 0.323004 8.31473 0.196107C8.13427 0.0692101 7.92179 0.00097084 7.70415 1.90735e-05Z"
                  fill="#0032A0" />
              </svg>
            </div>
          </div>
          <div class="search_data_table_body_box_container">
            <!-- List View -->
            <p-table [columns]="cols" [value]="products_current_datasource"
              [tableStyle]="{ 'background-color': '#fff' , }" styleClass="p-datatable-gridlines table_data"
              class="width_100_per" [lazy]="true" (onLazyLoad)="loadProducts($event)" [lazyLoadOnInit]="false"
              [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading_table"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="TableRowsCounts" responsiveLayout="scroll" scrollDirection="horizontal"
              [scrollable]="true" scrollHeight="1285px" paginatorDropdownAppendTo="body">
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <ng-container *ngFor="let col of columns">
                    <col *ngIf="(col.isDisplay == 1 || col.isDisplay == true)" [ngStyle]="{ 'width.px': col.columnWidth }" />
                  </ng-container>
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr class="color_black font_14 weight_600">
                  <ng-container *ngFor="let col of columns">
                    <th [pSortableColumn]="col.field" *ngIf="(col.isDisplay == 1 || col.isDisplay == true)">
                      <div [ngStyle]="{ 'width.px': col.columnWidth }" style="display: flex; align-items: center">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                      </div>
                    </th>
                  </ng-container>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of columns">
                    <th [ngClass]="filterClass(col)" *ngIf="(col.isDisplay == 1 || col.isDisplay == true)">
                      <div [ngStyle]="{ 'width.px': col.columnWidth }">
                        <p-columnFilter style="width: 100%" [type]="col.fieldDataType" [field]="col.field"
                          matchMode="contains" [matchModeOptions]="
                            col.fieldDataType == 'date'
                              ? matchModeOptions
                              : null
                          " [showOperator]="false" [showAddButton]="false" [display]="
                            col.fieldDataType == 'date' ? 'menu' : 'row'
                          ">
                          <ng-template *ngIf="col.fieldDataType == 'date'" pTemplate="filter">
                            <p-calendar [yearNavigator]="true" yearRange="1900:2100" [(ngModel)]="dateValue[col.field]"
                              name="dateValue" (onSelect)="filterDate($event, col.field)">
                            </p-calendar>
                          </ng-template>
                        </p-columnFilter>
                      </div>
                    </th>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="color_black font_12 weight_500">
                  <ng-container *ngFor="let col of columns">
                    <td *ngIf="(col.isDisplay == 1 || col.isDisplay == true)" class="table__td">
                      <div class="table__tddatabox" [ngStyle]="{ 'width.px': col.columnWidth }">
                        <!-- <span
                                                    *ngIf="col.field != 'companyLogo' && col.field != 'patentType' && col.field != 'parentPatentPublicationNumber' && col.field != 'patentPublicationNumber' && col.field != 'abstract' && col.field != 'description' && col.field != 'claims'"
                                                    [innerHtml]="addDataSpace(rowData[col.field])"
                                                    classToApply="highlight__keyword_1"></span> -->
                        <span *ngIf="
                            col.field != 'companyLogo' &&
                            col.field != 'patentType' &&
                            col.field != 'parentPatentPublicationNumber' &&
                            col.field != 'patentPublicationNumber' &&
                            col.field != 'abstract' &&
                            col.field != 'description' &&
                            col.field != 'claims'
                          " appHighlight [searchedWords]="searchedWords" [text]="addDataSpace(rowData[col.field])"
                          classToApply="highlight__keyword_1"></span>
                        <span *ngIf="col.field === 'patentType'" appHighlight [searchedWords]="searchedWords"
                          [text]="addDataSpace(rowData[col.field])" classToApply="highlight__keyword_1"
                          [style.background-color]="
                            dynSelectedPatentType
                              ? patentClass(rowData.patentType)
                              : ''
                          "></span>
                        <img *ngIf="col.field == 'companyLogo'" [src]="
                            'https://chemrobotics.com/agropat/images/innovators_logo/' +
                            rowData[col.field]
                          " alt="" width="30%" class="mr-2" />
                        <span *ngIf="
                            col.field == 'abstract' ||
                            col.field == 'description' ||
                            col.field == 'claims'
                          " appHighlight [searchedWords]="searchedWords" [text]="addDataSpace(rowData[col.field])"
                          classToApply="highlight__keyword_1"></span>
                        <ng-container *ngIf="rowData[col.field]">
                          <img *ngIf="col.field == 'CountryName'" [src]="
                              './assets/img/flag_images/' +
                              rowData[col.field] +
                              '.png'
                            " alt="" width="40" class="mr-2" />
                        </ng-container>
                        <div *ngIf="
                            (col.field == 'patentPublicationNumber' ||
                              col.field == 'parentPatentPublicationNumber') &&
                            rowData[col.field]
                          ">
                          <span class="fnt-stl" pTooltip="{{ rowData.patentType }}" [style.background-color]="
                              patentClass(rowData.patentType)
                            ">{{ rowData[col.field] }}</span><br />
                          <a target="_blank" pTooltip="Search in Espacenet Patent" [href]="
                              'https://worldwide.espacenet.com/patent/search/family/ 072427821/publication/WO2020183288A1?q=' +
                              this.getPatentNumber(rowData[col.field])
                            " class="mr-2" style="color: #be0f05"><span><i class="fa fa-etsy"
                                aria-hidden="true"></i></span>&nbsp;Espacenet Patent Search</a><br />
                          <a target="_blank" pTooltip="Search in Google Patent" [href]="
                              'https://patents.google.com/patent/' +
                              this.getPatentNumber(rowData[col.field])
                            " class=""><span><i class="fa fa-google" aria-hidden="true"></i></span>&nbsp;Google Patent
                            Search</a>
                        </div>
                        <div class="read-more-btn" *ngIf="rowData[col.field]?.length > 65">
                          <button (click)="
                              showReadMore(col.header, rowData[col.field])
                            " type="button">
                            <i class="pi pi-window-maximize" style="font-size: 14px"></i>
                            Read More
                          </button>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div
            class="scroll-button-right bg_1 width_40 height_40 border-radius-50-per padding-3 m-t-30 m-l-20-neg z_index_3 shadow_effect_2 cursor_pointer"
            longPress (mouseLongPress)="scrollRight()" (click)="scrollRight()">
            <div class="bg_2 width_100_per height_100_per dis_flex jc_center align_center border-radius-50-per">
              <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z"
                  fill="#0032A0" />
              </svg>
            </div>
          </div>
        </div>
        <div class="p-x-10">
          <!-- Grid View -->
          <p-table [columns]="cols" [value]="products_current_datasource"
            [tableStyle]="{ width: '100%', 'background-color': '#fff' }" styleClass="p-datatable-gridlines table_data"
            responsiveLayout="scroll" scrollDirection="horizontal" [scrollable]="true" scrollHeight="1285px"
            [rows]="rows" [totalRecords]="totalRecords" (onLazyLoad)="loadProducts($event)" [lazy]="true"
            [loading]="loading_table" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="TableRowsCounts" [lazyLoadOnInit]="false" [paginator]="true" *ngIf="!isListView"
            paginatorDropdownAppendTo="body">
            <ng-template pTemplate="body" let-rowData>
              <div class="table__list__item shadow_effect_3" style="border: 1px solid #0032a0" [ngClass]="
                  rowData.S_NO === detailViewData.S_NO
                    ? 'table__list__item__selected'
                    : 'table__list__item__unselected'
                " (click)="detailView(rowData)">
                <ng-container *ngFor="let col of cols">
                  <div class="table__list__item__box" *ngIf="(col.isDisplay == 1 || col.isDisplay == true)">
                    <h5 class="table__list__item__header">{{ col.header }}</h5>
                    <div class="table__list__item__data">
                      <span *ngIf="
                          col.field != 'companyLogo' &&
                          col.field !== 'patentType' &&
                          col.field != 'parentPatentPublicationNumber' &&
                          col.field != 'patentPublicationNumber' &&
                          col.field != 'abstract' &&
                          col.field != 'description' &&
                          col.field != 'claims'
                        " appHighlight [searchedWords]="searchedWords" [text]="addDataSpace(rowData[col.field])"
                        classToApply="highlight__keyword_1"></span>
                      <span *ngIf="col.field === 'patentType'" appHighlight [searchedWords]="searchedWords"
                        [text]="addDataSpace(rowData[col.field])" classToApply="highlight__keyword_1"
                        [style.background-color]="patentClass(rowData.patentType)"></span>
                      <span *ngIf="
                          col.field == 'abstract' ||
                          col.field == 'description' ||
                          col.field == 'claims'
                        " appHighlight [searchedWords]="searchedWords" [text]="addDataSpace(rowData[col.field])"
                        classToApply="highlight__keyword_1"></span>
                      <span *ngIf="rowData[col.field] == ''"></span>
                      <div *ngIf="
                          (col.field == 'patentPublicationNumber' ||
                            col.field == 'parentPatentPublicationNumber') &&
                          rowData[col.field]
                        ">
                        <span class="fnt-stl" pTooltip="{{ rowData.patentType }}" [style.background-color]="
                            patentClass(rowData.patentType)
                          ">{{ rowData[col.field] }}</span><br />
                        <a target="_blank" pTooltip="Search in Espacenet Patent" [href]="
                            'https://worldwide.espacenet.com/patent/search/family/072427821/publication/WO2020183288A1?q=' +
                            this.getPatentNumber(rowData[col.field])
                          " class="mr-2" style="color: #be0f05"><span><i class="fa fa-etsy"
                              aria-hidden="true"></i></span>&nbsp;Espacenet Patent Search</a><br />
                        <a target="_blank" pTooltip="Search in Google Patent" [href]="
                            'https://patents.google.com/patent/' +
                            this.getPatentNumber(rowData[col.field])
                          " class=""><span><i class="fa fa-google" aria-hidden="true"></i></span>&nbsp;Google Patent
                          Search</a>
                      </div>
                      <img *ngIf="col.field == 'CountryName'" [src]="
                          './assets/img/flag_images/' +
                          rowData[col.field] +
                          '.png'
                        " alt="" width="40" class="ml-2" />
                      <img *ngIf="col.field == 'companyLogo'" [src]="
                          'https://chemrobotics.com/agropat/images/innovators_logo/' +
                          rowData[col.field]
                        " alt="" width="30%" class="ml-2" />
                      <div class="read-more-btn" *ngIf="rowData[col.field]?.length > 65">
                        <button (click)="showReadMore(col.header, rowData[col.field])" type="button">
                          <i class="pi pi-window-maximize" style="font-size: 14px"></i>
                          Read More
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="search_data_table_detail p-top-10" *ngIf="productDetails && !isListView">
        <div class="bg_1 border-radius-10 height_100_per" style="height: 100%; overflow-y: auto">
          <div class="bg_8 p-y-16 p-x-24 border-top-radius-10 color_black font_14 weight_700"
            style="padding-left: 15px; background: #ffcd04">
            {{ detailViewData.S_NO }}.
            {{ detailViewData.patentPublicationNumber }} -
            {{ detailViewData.title }}
          </div>
          <div class="dis_flex flex_wrap p-x-12 p-y-10 border_bottom_blue_1"
            style="margin-top: 15px; padding-left: 15px">
            <ng-container *ngFor="let tab of detailViewTabs; let i = index">
              <ng-container *ngIf="
                  detailViewData[tab.field] || tab.header === 'BIBLIOGRAPHY'
                ">
                <button style="
                    padding: 10px 24px;
                    margin: 0 12px 10px 0;
                    border-radius: 10px;
                    border: 1px solid #007bff; 
                    font-size: 13px;
                    cursor: pointer;
                    font-weight: {{
                    selectedDetailViewIndex === i ? '700' : '600'
                  }};
                    background-color: {{
                    selectedDetailViewIndex === i ? '#0032a0' : '#f5f5f5'
                  }}; 
                    color: {{
                    selectedDetailViewIndex === i ? '#ffffff' : '#0032a0'
                  }};" (click)="selectedDetailViewIndex = i">
                  {{ tab.header }}
                </button>
              </ng-container>
            </ng-container>
          </div>

          <div
            class="search_data_table_detail_item p-y-8 p-x-8 p-b-24 color_black font_12 weight_500 height_100_per overflow_auto"
            *ngIf="selectedDetailViewIndex === 0">
            <div class="search_data_table_detail_item_list">
              <div class="search_data_table_detail_item_list_content1">
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.patentType">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    PATENT TYPE
                  </div>
                  <div class="p-top-8 fnt-stl" [style.background-color]="patentClass(detailViewData.patentType)">
                    {{ detailViewData.patentType }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.product">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    PRODUCT
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.product }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word"
                  *ngIf="detailViewData.patentPublicationNumber">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    PATENT PUBLICATION NUMBER
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.patentPublicationNumber }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.assignee">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    ASSIGNEE
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.assignee }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word"
                  *ngIf="detailViewData.publicationDate">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    PUBLICATION DATE
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.publicationDate }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word"
                  *ngIf="detailViewData.applicationDate">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    APPLICATION DATE
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.applicationDate }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word"
                  *ngIf="detailViewData.estimatedExpiry">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    ESTIMATED EXPIRY
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.estimatedExpiry }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word"
                  *ngIf="detailViewData.applicationNumber">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    APPLICATION NUMBER
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.applicationNumber }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.inventors">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    INVENTORS
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.inventors }}
                  </div>
                </div>
              </div>
              <div class="search_data_table_detail_item_list_content2">
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.companyLogo">
                  <img class="float-right" [src]="
                      'https://chemrobotics.com/agropat/images/innovators_logo/' +
                      detailViewData.companyLogo
                    " alt="logo" width="50%" />
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.title">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    TITLE
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.title }}
                  </div>
                </div>
                <div class="p-top-16 p-x-16 word_wrap" style="word-wrap: break-word" *ngIf="detailViewData.abstract">
                  <div class="font_14 weight_700" style="font-size: 14; font-weight: 700">
                    ABSTRACT
                  </div>
                  <div class="p-top-8">
                    {{ detailViewData.abstract }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-24" style="padding: 15px">
            <div class="search_data_table_detail_item color_black font_12 weight_500 height_100_per overflow_auto"
              style="font-size: 12px; font-weight: 500" *ngIf="selectedDetailViewIndex !== 0">
              <span [innerHtml]="
                  detailViewData[detailViewTabs[selectedDetailViewIndex].field]
                "></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Raise Query Form -->
<div class="modal fade bg_4" id="raise_query_modal" tabindex="-1" aria-labelledby="sign_in" aria-hidden="true"
  *ngIf="initializedForm">
  <div class="modal-dialog text-center modal-dialog-centered">
    <div class="modal-content p-x-15 bg_1">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 30 30">
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z">
          </path>
        </svg>
      </div>
      <div class="dis-block-2">
        <div class="p-top-32">
          <span class="text_blue_9">Raise Query</span>
        </div>
      </div>
      <div class="modal-body">
        <form [formGroup]="form_RaiseQuery" (submit)="submitRaiseQueryForm()">
          <div class="mb-3">
            <label for="user_email" class="form-label dis-flex-4 text_grey_2">Response Email</label>
            <input type="text" class="form-control text_grey_3" id="user_email" formControlName="txtResponseEmail"
              placeholder="Enter Email ID / User ID" required />
          </div>
          <div class="mb-3">
            <label for="password" class="form-label dis-flex-4 text_grey_2">Comments</label>
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" formControlName="txtQuery"
              placeholder="Enter Your Comments"></textarea>
          </div>

          <div class="input-group mb-3">
            <input type="file" #fileInput class="form-control" id="inputGroupFile01"
              (change)="onFileSelected($event)" />
          </div>

          <div class="mb-3 text_start color_black font_14">
            <span class="weight_700">Your Search Query:</span>
            <p class="weight_500">{{ searchQueryGrid }}</p>
          </div>
          <div class="dis_flex jc_end mb-3">
            <button type="submit" class="button_blue_6 text_white_1 p-x-66 p-y-16">
              Submit
            </button>
          </div>
        </form>
        <div class="color_black font_14 weight_500 text_start mb-3">
          ChemRobotics Team happy to serve you !!! Your query will be answered
          soon.
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="Querysubmitalert" tabindex="-1" aria-labelledby="alertModelLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-success alert-dismissible fade show text-align-center" role="alert">
          Thank you for your query. The ChemRobotics Team will get in touch with
          you soon.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Field Settings Form -->
<div class="modal fade bg_4 fields_modal" id="field_setting_modal" tabindex="-1" aria-labelledby="sign_in"
  aria-hidden="true" style="z-index: 9000000000" *ngIf="allCols.length">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg_1">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 30 30">
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z">
          </path>
        </svg>
      </div>
      <div class="modal-body fields_modal_body">
        <div class="fields_modal_body_top">
          <div class="fields_modal_body_top_item1 color_blue font_20 weight_700">
            Fields Setting
          </div>
          <div class="fields_modal_body_top_item2">
            <span class="color_black font_16 weight_600">Field(s) Count: </span><span
              class="color_blue font_16 weight_800">{{
              allCols.length
              }}</span>
          </div>
          <div class="fields_modal_body_top_item3">
            <img class="fields_modal_body_top_item3_icon" src="../../../assets/icons/search_icon.png" />
            <input type="text" placeholder="Search fields" class="fields_modal_body_top_item3_input" />
          </div>
        </div>
        <div style="
            display: flex;
            justify-content: center;
            position: relative;
            z-index: 60450;
            margin-top: 15px;
          ">
          <table style="
              border-collapse: collapse;
              width: auto;
              font-family: Arial, sans-serif;
              font-size: 14px;
              min-width: 600px;
              background-color: #fff;
              position: relative;
              z-index: 10;
              border: 1px solid #ccc;
            ">
            <tr style="border-bottom: 1px solid #ccc">
              <th style="
                  padding: 10px 12px;
                  text-align: left;
                  border-left: 1px solid #ccc;
                ">
                Field Name
              </th>
              <th style="
                  padding: 10px 12px;
                  text-align: left;
                  border-left: 1px solid #ccc;
                  border-right: 1px solid #ccc;
                ">
                Width(px)
              </th>
              <th style="
                  padding: 10px 12px;
                  text-align: left;
                  border-left: 1px solid #ccc;
                  border-right: 1px solid #ccc;
                ">
                Show/Hide
              </th>
            </tr>
            <ng-container *ngFor="let col of allCols">
              <tr style="border-bottom: 1px solid #ddd">
                <td style="
                    padding: 10px 12px;
                    color: #000;
                    font-weight: 500;
                    border-left: 1px solid #ccc;
                    border-right: 1px solid #ccc;
                  ">
                  {{ col.header }}
                </td>

                <td style="
                    padding: 10px 12px;
                    border-left: 1px solid #ccc;
                    border-right: 1px solid #ccc;
                  ">
                  <button (click)="decrement(col)" style="
                      background-color: #004aad;
                      color: #fff;
                      border: none;
                      padding: 6px 10px;
                      cursor: pointer;
                    ">
                    -
                  </button>
                  <input type="number" [(ngModel)]="col.columnWidth" style="
                      width: 60px;
                      text-align: center;
                      padding: 6px;
                      margin: 0 4px;
                      border: 1px solid #ccc;
                    " />
                  <button (click)="increment(col)" style="
                      background-color: #004aad;
                      color: #fff;
                      border: none;
                      padding: 6px 10px;
                      cursor: pointer;
                    ">
                    +
                  </button>
                </td>

                <td style="
                    padding: 10px 12px;
                    border-left: 1px solid #ccc;
                    border-right: 1px solid #ccc;
                  ">
                  <div *ngIf="col.isDisplay" style="cursor: pointer" (click)="col.isDisplay = 0">
                    <img src="../../../assets/icons/visiblity_icon.png" style="width: 20px; height: 20px" />
                  </div>
                  <div *ngIf="!col.isDisplay" style="cursor: pointer" (click)="col.isDisplay = 1">
                    <img src="../../../assets/icons/visiblity_off_icon.png" style="width: 20px; height: 20px" />
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>

        <div class="fields_modal_body_bottom">
          <button class="bg_3 color_white font_15 weight_600 border-radius-35 border_none p-x-56 p-y-16"
            (click)="saveColumnDetails()" style="
              background-color: blue;
              color: white;
              font-size: 15px;
              font-weight: 600;
              border-radius: 35px;
              border: none;
              padding-left: 56px;
              padding-right: 56px;
              padding-top: 16px;
              padding-bottom: 16px;
            ">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Read More Dialog -->
<div class="modal fade bg_4 fields_modal" id="read_more_modal" tabindex="-1" aria-labelledby="read_more"
  aria-hidden="true" style="z-index: 900000000">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg_1" style="position: relative">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 30 30">
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z">
          </path>
        </svg>
      </div>
      <div class="modal-body fields_modal_body">
        <div class="fields_modal_body_top">
          <div class="fields_modal_body_top_item1 color_blue font_20 weight_700">
            {{ readMoreColumn }}
          </div>
        </div>
        <div class="fields_modal_body_center">
          <div appHighlight [searchedWords]="searchedWords" [text]="readMoreContent"
            classToApply="highlight__keyword_1"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Alert Dialogs if user not have privilege -->

<!-- Search Privilege dialog -->
<p-dialog header="Search Privilege" [(visible)]="is_show_Search_Priv_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't have permission to Search, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Search Exceed dialog -->
<p-dialog header="Daily Search Exceed" [(visible)]="is_show_Daily_Search_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily search limit, please contact the support team
      at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Search Exceed  dialog -->
<p-dialog header="Total Search Exceed" [(visible)]="is_show_Total_Search_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your search count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Download  Privilege dialog -->
<p-dialog header="Download Privilege" [(visible)]="is_show_Download_Priv_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't permission to download, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Download Exceed dialog -->
<p-dialog header="Daily Download Exceed" [(visible)]="is_show_Daily_Download_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily download limit, please contact the support
      team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Downalod Exceed  dialog -->
<p-dialog header="Total Download Exceed " [(visible)]="is_show_Total_Download_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your download count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>